import React from "react";
import { CardTitle, SubTitle } from "../CustomComponents";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { FaRectangleXmark } from "react-icons/fa6";

const ViewTravelInsightData = ({ data }) => {
  return (
    <div className="w-100 mt-3">
      <p className="p-0 m-0 fs-7 fw-normal text-black">{data?.prompt}</p>
    </div>
  );
};

export default ViewTravelInsightData;
